// extracted by mini-css-extract-plugin
export var active = "_aj-a";
export var activeIndicator = "_aj-8";
export var animate = "_aj-9";
export var disabled = "_aj-b";
export var fullWidth = "_aj-2";
export var lg = "_aj-7";
export var md = "_aj-6";
export var redoButtonTabGroup = "_aj-0";
export var sm = "_aj-5";
export var tabButton = "_aj-3";
export var tabButtonsContainer = "_aj-1";
export var xs = "_aj-4";